import LayoutPrimary from '../../layouts/Primary';
import FieldCreate from '../../views/Admin/Config/Field/FieldCreate';
import FieldIndex from '../../views/Admin/Config/Field/FieldIndex';
import FieldEdit from '../../views/Admin/Config/Field/FieldEdit';

export default [
    {
        path: '/field/create',
        name: 'FieldCreate',
        component: FieldCreate,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
    {
        path: '/field/index',
        name: 'FieldIndex',
        component: FieldIndex,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
        props: true,
    },
    {
        path: '/field/edit/:id',
        name: 'FieldEdit',
        component: FieldEdit,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
];
